<template>
  <b-card>
    <FormView
      :data="$store.getters['courierService/detailData']"
      :fields="$store.getters['courierService/tableFields']"
      @load="loadData"
    />
  </b-card>
</template>

<script>
import FormView from '@/layouts/components/v2/FormView.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    FormView,
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('courierService/getDetail', id)
    },
  },
}
</script>

<style scoped>

</style>
